var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-radio-group',{attrs:{"options":_vm.options,"value":_vm.value},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }